var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "full-board-top" },
    [
      _c("TaiXiuFullVideo", {
        staticClass: "full-board-top__video",
        attrs: { "arena-id": _vm.table.arenaId },
      }),
      _c("TaiXiuBoardHeader", {
        staticClass: "full-board-top__header",
        attrs: {
          table: _vm.table,
          "is-rolling": _vm.isRolling,
          "use-name": "",
          "float-result": "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }